import RootStore from '@App/stores/root-store'
import { action, makeObservable, observable, runInAction } from 'mobx'
import { getNewRightsholderQuestions, submitCreateRightsholder } from '@App/api/routes/rightsholder/rightsholder'
import { Question } from '@Entities/questionnaire/question'
import CreateRightsholderDto, { CreateRightsholderForm } from '@Entities/rightsholder/create-rightsholder-dto'
import { QuestionAnswer } from '@Entities/questionnaire/question-answer'

class CreateRightsholderStore {
    private rootStore: RootStore

    private _questions: Question[]

    private _createRightsholder: Partial<CreateRightsholderDto> | undefined

    constructor(rootStore: RootStore) {
        makeObservable<CreateRightsholderStore, '_questions' | '_createRightsholder'>(this, {
            _questions: observable,
            _createRightsholder: observable,
            setCreateRightsholderForm: action,
            setCreateRightsholderQuestionnaire: action,
        })
        this.rootStore = rootStore
        this._questions = []
    }

    get questions(): Question[] {
        return this._questions
    }

    get createRightsholder(): Partial<CreateRightsholderDto> {
        return this._createRightsholder ?? this.getDefaultCreateRightsholder()
    }

    public loadQuestions = async (): Promise<void> => {
        const reply = await getNewRightsholderQuestions()
        runInAction(() => {
            this._questions = reply.data.data
        })
    }

    public setCreateRightsholderForm = (createRightsholder: CreateRightsholderForm) => {
        this._createRightsholder = {
            ...this._createRightsholder,
            ...createRightsholder,
        }
    }

    public setCreateRightsholderQuestionnaire = (questionAnswers: QuestionAnswer[]) => {
        if (this._createRightsholder) {
            this._createRightsholder.questionAnswers = questionAnswers
        } else {
            this._createRightsholder = {
                questionAnswers,
            }
        }
    }

    public submitCreateRightsholder = async () => {
        if (!this.rootStore.userStore.userInfo.isInternal && this._createRightsholder) {
            const createRightsholderRequest = this._createRightsholder
            await submitCreateRightsholder(createRightsholderRequest)
            await this.rootStore.rightsholderSearchStore.loadRightsholders({})
            runInAction(() => (this._createRightsholder = undefined))
        }
    }

    private getDefaultCreateRightsholder = () => ({
        name: '',
        hfaPublisherNumber: '',
        ipiNumber: '',
        isni: '',
        address: {
            streetAddress: '',
            unitNumber: '',
            city: '',
            state: '',
            countryId: '',
            postalCode: '',
        },
        phoneNumber: {
            phoneCountryCode: '',
            phoneAreaCode: '',
            phoneNumber: '',
        },
        email: '',
        termsAndConditions: false,
    })
}

export default CreateRightsholderStore
